var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"blocks",style:({ background: _vm.bg_color }),attrs:{"id":"block4"}},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"title-box"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('article',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.content)+"\n\t\t\t")]),_vm._v(" "),_c('figure',[_c('img',{attrs:{"src":_vm.figure,"alt":_vm.title}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfdf12e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/blocks/Block4.vue
// module id = 110
// module chunks = 0